import gsap from 'gsap';
import { playCartSwoosh } from './audioEffects';

export const flyToCart = (event: React.MouseEvent, imgSrc: string) => {
  // 1. Play tactile sound effect immediately
  playCartSwoosh();

  // 2. Identify target Cart icon (find the one that is currently visible on screen)
  const cartIcons = Array.from(document.querySelectorAll('.js-cart-icon'));
  const visibleCartIcon = cartIcons.find(icon => {
      const rect = icon.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
  });

  if (!visibleCartIcon) return;

  const targetRect = visibleCartIcon.getBoundingClientRect();
  const startX = event.clientX;
  const startY = event.clientY;

  // 3. Create the flying copy of the product image
  const clone = document.createElement('img');
  clone.src = imgSrc;
  clone.style.position = 'fixed';
  clone.style.left = `${startX - 25}px`; // Centered exactly under the mouse click pointer
  clone.style.top = `${startY - 25}px`;
  clone.style.width = '50px';
  clone.style.height = '50px';
  clone.style.objectFit = 'cover';
  clone.style.borderRadius = '50%';
  clone.style.border = '2px solid rgba(168,85,247,0.8)';
  clone.style.zIndex = '999999';
  clone.style.pointerEvents = 'none';
  clone.style.boxShadow = '0 0 30px rgba(168,85,247,0.6)'; // Neon purple glow
  
  document.body.appendChild(clone);

  // 4. Straight Diagonal Animation
  // Combining x and y into the same tween with the same ease makes it travel in a straight line.
  
  const distanceX = targetRect.left - startX + 15;
  const distanceY = targetRect.top - startY + 15;

  gsap.to(clone, {
    x: distanceX,
    y: distanceY,
    ease: "power2.inOut",
    duration: 0.6,
    scale: 0.1,
    opacity: 0.1,
    onComplete: () => {
      // Clean up the clone from the DOM
      clone.remove();
      
      // 5. Visual confirmation pulse on the primary Cart Icon when the item "lands"
      gsap.fromTo(visibleCartIcon, 
        { scale: 1 },
        { scale: 1.3, duration: 0.15, yoyo: true, repeat: 1, ease: "power1.inOut" }
      );
    }
  });
};
